import React from 'react';
import { getSelectedPrice } from '@features/price-graph';
export const useSelectedPrice = (prices, openedDate) => {
    return React.useMemo(() => getSelectedPrice(prices, openedDate), [prices, openedDate]);
};
